import { DashboardFeatureId } from '../AdviserArea/AdviserArea.types';
import { OnboardingWorkflow } from '../CommonSelectors/CommonArea.types';
import { ModelGroupDTO } from './api/useModelPortfolioGroupsQuery';
import { OptionType } from '../CommonComponents/OPL/Select/BaseSelect/types';

interface OnboardingWorkflowOption {
  label: string;
  value: OnboardingWorkflow;
}

export enum LandingPage {
  Overview,
  GoalResults,
  PersonalFinances,
  Profile,
  Reports,
  DocumentVault,
  CreditMonitoring,
  Newsfeed,
  AssetBucketing,
  BeFi20,
  PersonalFinancesSummary,
  PersonalFinancesPositions,
  PersonalFinancesNetWorth,
  PulseCheck,
}

export enum BehavioralFinanceTools {
  AssetBucketing = 11,
  BeFi20 = 12,
  Rtq = 13,
  PulseCheck = 14,
}

export interface ClientAccessDTO {
  CurrentOnboardingWorkflow: OnboardingWorkflow | null;
  DashboardAccessSet: DashboardFeatureId[] | null;
  DefaultDashboardAccessSet: DashboardFeatureId[];
  LinkAccountsAccess: boolean;
  CreditMonitoringAccess: boolean;
  DataReconciliationAccess: boolean;
  ClientLandingPage: LandingPage | null;
  DefaultClientLandingPage: LandingPage;
  ClientLandingPageOptions: OptionType<LandingPage>[];
  LastCompletedOnboardingDate: string;
  LastCompletedOnboardingName: string;
  ShowProBono: boolean;
  IsProBonoClient: boolean;
  TaxableAccountModelGroup: ModelGroupDTO | null;
  NonTaxableAccountModelGroup: ModelGroupDTO | null;
  FullyAutomatedAccountOpening: boolean;
  AgreementOptions: { Label: string; Value: string }[];
  SelectedAgreements: string[] | null;
  IsPreviewLinkEnabled: boolean;
  OnboardingWorkflowOptions: OnboardingWorkflowOption[];
  CanAddManualAccount: boolean | null;
  DisplayAddManualAccountToggle: boolean;
  HasOrionReportsEnabled: boolean;
  DisplayMobileAppPushNotificationsSection: boolean | null;
  AllowMobileAppPushNotifications: boolean | null;
  DefaultDocumentUploadMobilePushNotifications: boolean | null;
  HasDocumentVaultFirm: boolean;
  DisplayBehavioralFinanceSection: boolean;
  HiddenBeFiTools: BehavioralFinanceTools[];
}

export interface ClientAccessSettingsState {
  dashboardAccess: DashboardFeatureId[] | null;
  onboardingWorkflow: OnboardingWorkflow | null;
  linkAccountsAccess: boolean;
  creditMonitoringAccess: boolean;
  dataReconciliationAccess: boolean;
  isProBonoClient: boolean;
  taxableAccountModelGroup: ModelGroupDTO | null;
  nonTaxableAccountModelGroup: ModelGroupDTO | null;
  fullyAutomatedAccountOpening: boolean;
  clientLandingPage: LandingPage | null;
  selectedAgreements: string[] | null;
  canAddManualAccount: boolean;
  allowMobileAppPushNotifications: boolean;
  defaultDocumentUploadMobilePushNotifications: boolean;
}

export interface ClientAccessData extends ClientAccessSettingsState {
  defaultClientLandingPage: LandingPage;
  defaultDashboardAccessSet: DashboardFeatureId[];
  clientLandingPageOptions: OptionType<LandingPage>[];
  onboardingWorkflowOptions: OnboardingWorkflowOption[];
  completedOnboardingMessage: string | null;
  showProBono: boolean;
  agreementOptions: OptionType<string>[];
  isLoadingAgreementOptions?: boolean;
  isPreviewLinkEnabled: boolean;
  displayAddManualAccountToggle: boolean;
  hasOrionReportsEnabled: boolean;
  displayMobileAppPushNotificationsSection: boolean;
  defaultDocumentUploadMobilePushNotifications: boolean;
  allowMobileAppPushNotifications: boolean;
  hasDocumentVaultFirm: boolean;
  displayBehavioralFinanceSection: boolean;
  hiddenBeFiTools: BehavioralFinanceTools[];
}

export interface ClientAccessSettingsProps extends Partial<ClientAccessData> {
  dashboardAccess: DashboardFeatureId[] | null;
  onboardingWorkflow: OnboardingWorkflow | null;
  onboardingWorkflowOptions: OnboardingWorkflowOption[];
  showCreditMonitoring?: boolean;
  showDataAggregation?: boolean;
  showDataReconciliation?: boolean;
  showBeFi20?: boolean;
  clientId?: string;
  onChange(data: Partial<ClientAccessSettingsState>): void;
}

export interface SaveParams {
  isSaveAndPreview?: boolean;
  onSuccess?: () => void;
}
